import { render } from "./MulpumV6V2.vue?vue&type=template&id=16422108&scoped=true"
import script from "./MulpumV6V2.vue?vue&type=script&lang=js"
export * from "./MulpumV6V2.vue?vue&type=script&lang=js"

import "./MulpumV6V2.vue?vue&type=style&index=0&id=16422108&scoped=true&lang=css"
import "./MulpumV6V2.vue?vue&type=style&index=1&id=16422108&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16422108"]])

export default __exports__